import { render, staticRenderFns } from "./Signal.vue?vue&type=template&id=04bece42&scoped=true"
import script from "./Signal.vue?vue&type=script&lang=js"
export * from "./Signal.vue?vue&type=script&lang=js"
import style0 from "./Signal.vue?vue&type=style&index=0&id=04bece42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bece42",
  null
  
)

export default component.exports